<div class="four-o-four-page">
    <img class="four-o-four-img" src="../../../../assets/group-4@1x.png" />
    <button (click)="goBack()" class="four-o-four-button">Go Back</button>
</div>